import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconHourglassEmptyComponent } from "./med-icon-hourglass-empty.component";

@NgModule({
  declarations: [
    MedIconHourglassEmptyComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconHourglassEmptyComponent,
  ],
})
export class MedIconHourglassEmptyModule { }
